/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeGenerateParams } from './scheduledChangeGenerateParams';

/**
 * Request model for scheduled-change pool generation job.
 */
export interface RunScheduledChangeGenerateJobRequest {
  type: 'scheduled_change_generate';
  params: ScheduledChangeGenerateParams;
  allowOverlappingJobs?: boolean;
}
